import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-o",
  "use": "icon-close-o-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 18\" id=\"icon-close-o\"><path fill=\"#9D9D9D\" d=\"M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z\" /><path fill=\"#fff\" d=\"M5.985 6.353h1.556l1.687 2.073 1.761-2.073h1.46l-2.46 2.824 2.634 3.049h-1.588L9.186 9.98 7.3 12.226H5.81l2.637-3.049-2.46-2.824Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol